import { render, staticRenderFns } from "./AlignmentButton.vue?vue&type=template&id=47f88ebc"
import script from "./AlignmentButton.js?vue&type=script&lang=js&external"
export * from "./AlignmentButton.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports